import {
    Card, CardContent, TextField, Button, makeStyles, Input, Dialog, DialogContent, DialogActions
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { getRoles } from '../auth-provider/ra-auth-jwt';

const useStyles = makeStyles((theme) => ({
    cancelBtn: {
        backgroundColor: 'rgb(220, 0, 78)',
        width: '20%',
        '&:hover': {
            backgroundColor: 'rgb(220, 0, 78)'
        }
    }
}));



export function CancelSnappPayment() {
    const classes = useStyles();
    const [transactionId, setTransactionId] = useState("");
    const [serverState, setServerState] = useState({
        status: 'NONE',
        message: ''
    }
    )
    const [confirmationCancel, setConfirmationCancel] = useState(false)

    async function cancelPayment(transactionId: string) {
        setServerState({
            status: 'PENDING',
            message: ''
        })
        let token: any = localStorage.getItem('credentials')
        await axiosWithAuthInterceptor(
            {
                method: 'post',
                url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/payments/snapp-pay/cancel`,
                data: {
                    transactionId: transactionId
                },
            }

        ).then((res: any) => {
            if (res.data.err) {
                let message = "";
                switch (res.data.err.message) {
                    case "payment-not-found":
                        message = "سفارشی با این شماره پرداخت وجود ندارد"
                        break;
                    case "payment-not-settled-yet":
                        message = "پرداخت موفقی برای این شماره پرداخت وجود ندارد"
                        break;
                    case "snapp-error":
                        message = "خطا از طرف اسنپ"
                        break;
                    default:
                        message = "با خطا مواجه شد"
                        break;
                }
                setServerState({
                    status: 'ERROR',
                    message: message
                })
            }
            else {
                setServerState({
                    status: 'SUCCESSFUL',
                    message: "با موفقیت انجام شد"
                })
            }
        }).catch((error => {
            setServerState({
                status: 'ERROR',
                message: "با خطا مواجه شد"
            })
        })).finally(() => setConfirmationCancel(false))
    }

    useEffect(() => {
        let roles = getRoles();
        let isPaymentManager = roles.some((r: any) => r === `${process.env.REACT_APP_AUTH_SERVICE}.payment_manager`)
        if (!isPaymentManager)
            window.location.href = '/'
    })

    return (
        <Card>
            <CardContent>
                <Dialog
                    onClick={(e) => { e.preventDefault(); e.stopPropagation() }}
                    disableEscapeKeyDown
                    maxWidth="xs"
                    aria-labelledby="confirmation-dialog-title"
                    open={confirmationCancel}
                >
                    <DialogContent>
                        <p className="text-IranSans-Bold">
                            آیا از بازگشت کل وجه سفارش با شماره پرداخت {transactionId} مطمئن هستید؟
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={(e) => setConfirmationCancel(false)} color="primary">
                            لغو
                        </Button>
                        <Button onClick={(e) => cancelPayment(transactionId)} color="primary">
                            تایید
                        </Button>
                    </DialogActions>
                </Dialog>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '2rem' }}>
                    <Input
                        onChange={(e: any) => setTransactionId(e.target.value)}
                        value={transactionId}
                        placeholder="شماره پرداخت"
                        inputProps={{ 'aria-label': 'description' }}

                    />
                    <Button onClick={() => setConfirmationCancel(true)} className={classes.cancelBtn} variant="contained" color="secondary">
                        بازگشت وجه
                    </Button>
                </div>

                <p style={{ color: serverState.status === "ERROR" ? "rgb(220, 0, 78)" : "green", margin: '0px', textAlign: 'right', marginTop: '2rem' }} className="text-IranSans-Bold">
                    {serverState.message}
                </p>

            </CardContent>
        </Card>
    )
}